// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"d1fa0e61","440":"d6bcef0d","815":"920da9f5"}[chunkId] + ".chunk.js";
};